import axios from 'axios';
import { Action } from 'redux-actions';
import { all, takeLatest, select, call, put } from 'redux-saga/effects';
import { getProfileOwnerUser } from '../selectors/users';
import { API_BASE_PATH } from '../../constants';
import {
  fetchProfileOwnerGiveState,
  fetchProfileOwnerGiveStateSuccess,
  fetchProfileOwnerGiveStateFailure,
  fetchProfileOwnerSuccess,
  FetchProfileOwnerSuccessPayload,
} from '../actions/profileOwner';
import { setWatchingState } from '@wix/da-shared-react/pkg/WatchButton/redux/actionCreators';

function fetchFromApi(requestUrl, params) {
  return axios
    .get(`${API_BASE_PATH}/${requestUrl}`, { params })
    .catch(response => false);
}

export function* fetchProfileOwnerGiveStateSaga() {
  const profileOwnerUser = yield select(getProfileOwnerUser);

  const result = yield call(fetchFromApi, 'give_menu/status', {
    username: profileOwnerUser.username,
  });

  const data = result.data;

  if (!result.data) {
    yield put(fetchProfileOwnerGiveStateFailure());
  }

  yield put(
    fetchProfileOwnerGiveStateSuccess({
      canBeGivenLlama: data.canGiveLlama,
      canBeGivenCake: data.canGiveCake,
      canBeGivenCore: data.canGiveCore,
    })
  );
  return;
}
export function* setupWatchingStatusSaga(
  action: Action<FetchProfileOwnerSuccessPayload>
) {
  const { isWatching } = action.payload;
  const profileOwnerUser = yield select(getProfileOwnerUser);
  yield put(setWatchingState(profileOwnerUser.username, isWatching));

  return;
}

export default function* rootFeedSaga() {
  yield all([
    takeLatest(fetchProfileOwnerGiveState, fetchProfileOwnerGiveStateSaga),
    takeLatest(fetchProfileOwnerSuccess, setupWatchingStatusSaga),
  ]);
}
